import React from 'react';
import { UserItemContainer } from './UserAccessItemStyle';
import RoleSelect from './RoleSelect';
import Profile from 'components/Profile';

const UserAccessItem = ({ index, user, handleRoleChange, handleRemoveUser, disabled }) => {
  const { name = '', email = '', role = null } = user;
  const onSelectChange = (e) => {
    const value = e.target.value;
    if (value === 'remove') {
      handleRemoveUser(index);
    } else {
      handleRoleChange(index, value);
    }
  };

  return (
    <UserItemContainer>
      <Profile text={name} subText={email} />
      <RoleSelect
        disabled={disabled}
        value={role}
        onChange={onSelectChange}
        handleRemove={handleRemoveUser}
        index={index}
      />
    </UserItemContainer>
  );
};

export default UserAccessItem;
